module.exports = __webpack_public_path__ + "images/ZTO_Express-4c8d2a.png";